'use strict';

var _ = require('lodash');
var ConditionsAndActionsService = function ConditionsAndActionsService(configurationService, distanceUnitService, featureToggleService) {
  var templates = require('../../constants/templates.json');
  var operators = require('../../constants/operators.json');
  var actionsData = require('../../constants/actions.json');
  var alerts = require('../../constants/actions-alerts.json');
  var optimization = require('../../constants/actions-optimization.json');
  var allConditions = require('../../constants/conditions.json');
  function filterByFeature(criteria) {
    return !(criteria.showIfFeature && featureToggleService.isDisabled(criteria.showIfFeature) || criteria.hideIfFeature && featureToggleService.isEnabled(criteria.hideIfFeature));
  }
  function filterByHiddenOption(criteria) {
    return !criteria.hidden;
  }
  function forEveryCriteria(conditions, callback) {
    _.forEach(conditions, function (condition) {
      condition.categories = _.filter(condition.categories, filterByHiddenOption);
      _.forEach(condition.categories, function (category) {
        category.criteria = _.filter(category.criteria, filterByFeature);
        category.criteria = _.filter(category.criteria, filterByHiddenOption);
        _.forEach(category.criteria, function (criteria) {
          callback(criteria, category, condition);
        });
      });
    });
  }
  function forEveryActionCriteria(actions, callback) {
    _.forEach(actions, function (action) {
      _.forEach(action.categories, function (category) {
        category.criteria = _.filter(category.criteria, filterByFeature);
        _.forEach(category.criteria, function (criteria) {
          callback(criteria, category, action);
        });
      });
    });
  }
  var getConditions = _.memoize(function () {
    var conditions = _.cloneDeep(allConditions);

    // preprocessing of loaded conditions (add operators)
    forEveryCriteria(conditions, function (criteria) {
      if (_.isString(criteria.operators)) {
        criteria.operators = operators[criteria.operators];
      }
    });
    return conditions;
  });
  function getActions(sourceJson) {
    var actions = _.cloneDeep(sourceJson);

    // preprocessing of loaded actions (add actions)
    forEveryActionCriteria(actions, function (criteria) {
      if (_.isString(criteria.actions)) {
        criteria.actions = actionsData[criteria.actions];
      }
    });
    return actions;
  }
  var getOptimizationActions = _.memoize(getActions.bind(undefined, optimization));
  var getAlertActions = _.memoize(getActions.bind(this, alerts));
  function isApplicable(item, entityType) {
    return !item.applicability || item.applicability === entityType;
  }
  function isFlowTypeFieldMatch(item, flowType) {
    return !item.flowTypeField || item.flowTypeField && item.flowTypeField.value === flowType;
  }
  function isHideIfSelectedFlowType(item, flowType) {
    return _.isString(item.hideIfSelectedFlowType) && item.hideIfSelectedFlowType.match(flowType);
  }
  function isCorrectFlowType(condition, item, flowType) {
    return !flowType || !isHideIfSelectedFlowType(item, flowType) && (!condition.isFlowTypeSelectable || isFlowTypeFieldMatch(item, flowType));
  }
  function filterConditions(entityType, conditions, flowType) {
    var filteredConditions = _.filter(conditions, function (condition) {
      return isApplicable(condition, entityType);
    });
    _.forEach(filteredConditions, function (condition) {
      _.forEach(condition.categories, function (category) {
        category.criteria = _.filter(category.criteria, function (criteria) {
          return isApplicable(criteria, entityType) && isCorrectFlowType(condition, criteria, flowType);
        });
      });
      condition.categories = _.filter(condition.categories, function (category) {
        return category.criteria.length > 0 && isApplicable(category, entityType);
      });
    });
    return filteredConditions;
  }
  function filterActions(entityType, actions) {
    var filteredActions = _.filter(actions, function (action) {
      return isApplicable(action, entityType);
    });
    _.forEach(filteredActions, function (action) {
      _.forEach(action.categories, function (category) {
        category.criteria = _.filter(category.criteria, function (criteria) {
          return isApplicable(criteria, entityType);
        });
      });
      action.categories = _.filter(action.categories, function (category) {
        return category.criteria.length > 0 && isApplicable(category, entityType);
      });
    });
    return filteredActions;
  }
  function getFilteredConditions(flowType) {
    return {
      optimization: filterConditions('optimization', _.cloneDeep(getConditions()), flowType),
      alert: filterConditions('alert', _.cloneDeep(getConditions()), flowType)
    };
  }
  function getFilteredActions() {
    return {
      optimization: filterActions('optimization', _.cloneDeep(getOptimizationActions())),
      alert: filterActions('alert', _.cloneDeep(getAlertActions()))
    };
  }
  var templateOptions = _.map(templates, function (d) {
    return {
      name: d.name,
      id: d.id
    };
  });
  var applyDistanceUnitSuffix = _.memoize(function (entityType, flowType, conditions) {
    var clonedConditions = _.cloneDeep(conditions);
    forEveryCriteria(clonedConditions, changeCriterionDistanceSuffix);
    return clonedConditions;
  }, function (entityType, flowType) {
    return entityType + '-' + flowType + '-' + distanceUnitService.getSuffix();
  });
  function changeCriterionDistanceSuffix(criterion) {
    if (_.has(criterion, 'applyDistanceUnit') && criterion.applyDistanceUnit === true) {
      criterion.criteriaName = distanceUnitService.applySuffix(criterion.criteriaName);
    }
  }
  function getDefaultStrategyDomainLevel() {
    return configurationService.getStrategyDomainLevel();
  }
  function getActionByDomain(domain, entityType) {
    var filteredActions = getFilteredActions();
    return _.find(filteredActions[entityType], {
      'domain': domain
    });
  }
  function getConditionByDomain(domain, entityType, flowType) {
    var filteredConditions = getFilteredConditions(flowType);
    var cond = applyDistanceUnitSuffix(entityType, flowType, filteredConditions[entityType]);
    return _.find(cond, {
      'domain': domain
    });
  }
  function collectDefinedValues(level) {
    return _.reduce(level, function (result, value, key) {
      if (!_.isUndefined(value)) {
        result[key] = value;
      }
      return result;
    }, {});
  }
  function conditionLevelMapper(condition) {
    return condition ? collectDefinedValues({
      label: condition.label,
      domain: condition.domain,
      isFlowTypeSelectable: condition.isFlowTypeSelectable,
      flowTypeField: condition.flowTypeField
    }) : undefined;
  }

  /**
   * Returns available levels for a given applicability type.
   * If the applicability type is not defined it will return a given level.
   * @param entityType the applicability type
   * @returns {*}
   */
  function getLevels(entityType) {
    return _.chain(getConditions()).filter(function (condition) {
      return !condition.applicability || condition.applicability === entityType;
    }).filter(function (condition) {
      return filterByFeature(condition);
    }).map(conditionLevelMapper).value();
  }
  function getTemplates() {
    return templateOptions;
  }
  function getLevelByDomain(domain) {
    var condition = _.find(getConditions(), {
      'domain': domain
    });
    return conditionLevelMapper(condition);
  }
  function invalidateCache() {
    applyDistanceUnitSuffix.cache.clear();
    getConditions.cache.clear();
  }
  return {
    getDefaultStrategyDomainLevel: getDefaultStrategyDomainLevel,
    getActionByDomain: getActionByDomain,
    getConditionByDomain: getConditionByDomain,
    getLevels: getLevels,
    getTemplates: getTemplates,
    getLevelByDomain: getLevelByDomain,
    invalidateCache: invalidateCache
  };
};
ConditionsAndActionsService.$inject = ['ConfigurationService', 'DistanceUnitService', 'FeatureToggleService'];
module.exports = ConditionsAndActionsService;